import { render } from "./RiskTable.vue?vue&type=template&id=cb3b34f4&scoped=true"
import script from "./RiskTable.vue?vue&type=script&lang=js"
export * from "./RiskTable.vue?vue&type=script&lang=js"

import "./RiskTable.vue?vue&type=style&index=0&id=cb3b34f4&scoped=true&lang=css"
import "./RiskTable.vue?vue&type=style&index=1&id=cb3b34f4&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3b34f4"]])

export default __exports__